import Cookies from 'js-cookie'

const TokenKey = 'rapidToken'
const UserIdKey = 'UserId'
const UserEmailKey = 'UserEmail'
const FirstName = 'firstName'
const LastName = 'lastName'
import { _ } from 'vue-underscore'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeUserData() {
  Cookies.remove(TokenKey)
  Cookies.remove(UserIdKey)
  Cookies.remove(UserEmailKey)
}

export function getUserId() {
  return Cookies.get(UserIdKey)
}

export function setUserId(user_id) {
  return Cookies.set(UserIdKey, user_id)
}

export function setUserEmail(user_email) {
  return Cookies.set(UserEmailKey, user_email)
}

export function getUserEmail() {
  return Cookies.get(UserEmailKey)
}

export function setFirstName(user_fname) {
  return Cookies.set(FirstName, user_fname)
}

export function setLastName(user_lname) {
  return Cookies.set(LastName, user_lname)
}

export function getFirstName() {
  return Cookies.get(FirstName)
}

export function getLastName() {
  return Cookies.get(LastName)
}

export function getProfile() {
  let profile = {
    userId: Cookies.get(UserIdKey),
    userEmail: Cookies.get(UserEmailKey),
    firstName: Cookies.get(FirstName),
    lastName: Cookies.get(LastName)
  }
  return profile;
}